import { useCallback, useMemo } from 'react';

import { useFeatures } from '../../../../api/features';
import { EMPTY_ARR } from '../../../../constants';

export const useFeaturesManagement = () => {
  const { features, isLoading } = useFeatures();

  const getFeature = useCallback(
    (key: string) => features?.find((feature) => feature.key === key),
    [features],
  );

  const value = useMemo(
    () => ({
      features: features ?? EMPTY_ARR,
      getFeature,
    }),
    [features, getFeature],
  );

  return {
    value,
    isLoading,
  };
};
